module.exports = __webpack_public_path__ + "static/img/h14.13d95c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h14.jpg
// module id = Aa2T
// module chunks = 0